<template>
  <div class="left-panel">
    <div class="left-panel-heading">
      <img src="@/assets/images/skoda-logo.png" alt="Skoda" />
    </div>
    <navigation />
  </div>
</template>

<script>
import Navigation from './Navigation.vue';

export default {
  name: 'left-panel',

  components: {
    Navigation,
  },
};
</script>

<style lang="scss" scoped>
.left-panel {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  background: var(--white-color);

  .left-panel-heading {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 20px;
    border-bottom: 1px solid var(--light-grey-color);

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
